/**
 * Startseite nach dem Login im Kundenportal (Start unter „/“, dorthin führt die Anmeldung ohne ?weiter=): in die Agentur
 * bzw. ins Creator-Portal; Doppelrolle Agentur und Creator: zuletzt genutzter Bereich (Befund 16).
 * Seit dem internen Bereich (Inhaber 03.11.2026) führt das Kundenportal nie mehr in die Betreiber-Konsole: Die Konsole hat
 * ihre eigene Anmeldung unter /intern/anmelden; die frühere Einstellung „Nach dem Login“ (0330, start_area) wirkt nicht mehr.
 * Ein reines Mitarbeiterkonto bekommt im Kundenportal den Hinweis auf den internen Bereich (lib/bereich.ts, nurInternesKonto).
 */
export function startZiel(
  a: { memberships: readonly unknown[]; talentLinks: readonly unknown[] },
  zuletzt: string | null,
): "/agentur" | "/creator" | null {
  if (a.memberships.length && a.talentLinks.length && zuletzt === "creator") return "/creator";
  if (a.memberships.length) return "/agentur";
  if (a.talentLinks.length) return "/creator";
  return null;
}
